import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { ListingFormValues } from "@/components/listings/filters/FilterSchema";

interface PaymentTermsSectionProps {
  form: UseFormReturn<ListingFormValues>;
}

const PaymentTermsSection = ({ form }: PaymentTermsSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <FormField
        control={form.control}
        name="advancePayment"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Advance Payment (months)</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="e.g., 3"
                {...field}
                value={field.value ?? ""}
                onChange={(e) =>
                  field.onChange(parseFloat(e.target.value) || undefined)
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="minimumTermValue"
        render={({ field }) => {
          const minimumTermUnit = form.watch("minimumTermUnit", "months"); // Default to "months"
          return (
            <FormItem>
              <FormLabel>Minimum Term ({minimumTermUnit})</FormLabel>
              <div className="flex gap-2">
                <FormControl>
                  <Input
                    type="number"
                    placeholder="e.g., 12"
                    {...field}
                    value={field.value ?? ""}
                    onChange={(e) =>
                      field.onChange(parseFloat(e.target.value) || undefined)
                    }
                  />
                </FormControl>
                <FormField
                  control={form.control}
                  name="minimumTermUnit"
                  render={({ field: unitField }) => (
                    <FormItem className="w-[120px]">
                      <Select
                        onValueChange={unitField.onChange}
                        defaultValue={unitField.value || "months"}
                      >
                        <FormControl>
                          <SelectTrigger>
                            <SelectValue placeholder="Unit" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <SelectItem value="months">Months</SelectItem>
                          <SelectItem value="years">Years</SelectItem>
                        </SelectContent>
                      </Select>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
              <FormMessage />
            </FormItem>
          );
        }}
      />

      <FormField
        control={form.control}
        name="depositRequired"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Deposit Required (months)</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="e.g., 2"
                {...field}
                value={field.value ?? ""}
                onChange={(e) =>
                  field.onChange(parseFloat(e.target.value) || undefined)
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default PaymentTermsSection;
